// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`TdsAssets/styles/_tdsFormMain.scss`));
}

export {
  importCss ,
  
}
/* No side effect */
